import styled from 'styled-components';
import { Colors } from '~/config/Colors';

const isDark = localStorage.getItem('tema') === 'E';

export const EditorWrapper = styled.div`
  border: 1px solid ${isDark ? Colors?.Color5 : Colors?.Border_Color_1 || '#ddd'};
  border-radius: 8px;
  overflow: hidden;
  background: ${isDark ? Colors?.Color13 : Colors?.Input_Color_1 || '#fff'};
`;

export const EditorToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  background: ${isDark ? Colors?.Color12 : Colors?.Background_Color_2 || '#f5f5f5'};
  border-bottom: 1px solid ${isDark ? Colors?.Color5 : Colors?.Border_Color_1 || '#ddd'};
  align-items: center;
`;

export const ToolbarButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 4px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: ${Colors?.text_Color_1 || '#333'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${isDark ? Colors?.Color5 : Colors?.Background_Color_3 || '#e0e0e0'};
    border-color: ${isDark ? Colors?.Color6 : Colors?.Border_Color_2 || '#ccc'};
  }

  &.is-active {
    background: ${Colors?.Color4 || '#4285f4'};
    color: ${isDark ? Colors?.Color9 : '#ffffff'};
    border-color: ${Colors?.Color4 || '#4285f4'};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const EditorContainer = styled.div`
  position: relative;
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
  background: ${isDark ? Colors?.Color13 : Colors?.Input_Color_1 || '#fff'};

  /* Força renderização de imagens - múltiplos seletores para garantir */
  img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
    margin: 1em 0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .ProseMirror img {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
    margin: 1em 0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  .tiptap-image {
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
    margin: 1em 0 !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }

  /* .placeholder {
    position: absolute;
    top: 16px;
    left: 16px;
    color: ${isDark ? Colors?.Color6 : Colors?.text_Color_3 || '#999'};
    pointer-events: none;
    font-size: 14px;
  } */

  .tiptap-editor-content {
    padding: 16px;
    outline: none;
    min-height: 300px;
    color: ${isDark ? Colors?.Color9 : Colors?.text_Color_1 || '#333'};
    font-size: 14px;
    line-height: 1.6;

    /* Garantir que imagens apareçam dentro do conteúdo */
    img {
      max-width: 100% !important;
      height: auto !important;
      display: block !important;
      margin: 1em 0 !important;
      border-radius: 8px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
    }

    /* Estilos para os elementos do editor */
    h1 {
      font-size: 2em;
      font-weight: bold;
      margin: 0.67em 0;
      line-height: 1.2;
      color: ${Colors?.text_Color_1 || '#333'};
    }

    h2 {
      font-size: 1.5em;
      font-weight: bold;
      margin: 0.75em 0;
      line-height: 1.3;
      color: ${Colors?.text_Color_1 || '#333'};
    }

    h3 {
      font-size: 1.17em;
      font-weight: bold;
      margin: 0.83em 0;
      line-height: 1.4;
      color: ${Colors?.text_Color_1 || '#333'};
    }

    p {
      margin: 0.5em 0;
      color: ${Colors?.text_Color_1 || '#333'};
    }

    strong {
      font-weight: bold;
    }

    em {
      font-style: italic;
    }

    ul,
    ol {
      padding-left: 24px;
      margin: 0.5em 0;
      font-size: 14px;
    }

    ul {
      list-style-type: disc;
    }

    ol {
      list-style-type: decimal;
    }

    li {
      margin: 0.25em 0;
      font-size: 14px;
      line-height: 1.6;
    }

    blockquote {
      border-left: 4px solid ${Colors?.Color4 || '#4285f4'};
      padding-left: 16px;
      margin: 1em 0;
      color: ${Colors?.text_Color_2 || '#666'};
      font-style: italic;
    }

    code {
      background: ${Colors?.Color12 || 'rgba(110, 118, 129, 0.4)'};
      padding: 3px 6px;
      border-radius: 4px;
      font-family: 'Courier New', Courier, monospace;
      font-size: 14px;
      color: ${Colors?.Color9 || '#e8eaed'};
      border: 1px solid ${Colors?.Color5 || 'rgba(255, 255, 255, 0.1)'};
    }

    pre {
      background: ${Colors?.Color12 || 'rgba(110, 118, 129, 0.4)'};
      padding: 12px;
      border-radius: 6px;
      overflow-x: auto;
      margin: 1em 0;
      border: 1px solid ${Colors?.Color5 || 'rgba(255, 255, 255, 0.1)'};

      code {
        background: transparent;
        padding: 0;
        color: ${Colors?.Color9 || '#e8eaed'};
        border: none;
        font-size: 14px;
      }
    }

    /* Estilos para imagens - tanto tag img quanto classe */
    img,
    .tiptap-image {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      margin: 1em 0;
      display: block !important;
      cursor: pointer;
      transition: transform 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: scale(1.02);
      }
    }

    .tiptap-link {
      color: ${Colors?.Color4 || '#4285f4'};
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }

    hr {
      border: none;
      border-top: 2px solid ${Colors?.Border_Color_1 || '#ddd'};
      margin: 2em 0;
    }

    /* Estilo para quando está vazio */
    &:empty::before {
      content: attr(data-placeholder);
      color: ${Colors?.text_Color_3 || '#999'};
      pointer-events: none;
    }
  }

  /* Scrollbar customizada */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${isDark ? Colors?.Color12 : Colors?.Background_Color_2 || '#f5f5f5'};
  }

  &::-webkit-scrollbar-thumb {
    background: ${Colors?.Color27 || '#ccc'};
    border-radius: 4px;
    /*
    &:hover {
      background: ${isDark ? Colors?.Color6 : Colors?.Border_Color_3 || '#999'};
    } */
  }
`;
